import { Log } from '../AuxillaryService/Log';
import {
    AdWidget,
    AnnouncementWidget,
    BaseWidgetConfiguration,
    BroadsignWidget,
    ContentWidget,
    CounterWidget,
    CustomHtmlWidget,
    GraphicWidget,
    HivestackWidget,
    IframeWidget,
    LabelWidget,
    ListWidget,
    MapsWidget,
    PowerBIWidget,
    QuoteWidget,
    RadarWidget,
    ScheduleWidget,
    ScoresWidget,
    SocialMedallionWidget,
    TickerWidget,
    TimeDateWidget,
    VengoWidget,
    VideoStreamWidget,
    WeatherRadarWidget,
    WeatherWidget,
    Widget,
    WidgetType,
    VistarWidget,
    PlaceExchangeWidget,
} from './index';

export class WidgetFactory {
    static createWidget(widgetConfiguration: BaseWidgetConfiguration, zoneId: number): Widget {
        const widgetType = widgetConfiguration.type ?? WidgetType.GENERAL;
        const widgetClass = this.getWidgetClass(widgetType);

        //todo: How can this be refactored to not use 'as'?
        return new widgetClass(widgetConfiguration, zoneId);
    }

    /**
     * Return class constructor for a given widget type
     * todo: Why does ConstructorParameters<typeof GraphicsWidget> not extend
     *  ConstructorParameters<typeof Widget>? any[] could be replaced...
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static getWidgetClass(type: WidgetType): new (...args: any[]) => Widget {
        if (typeof type === 'undefined' || type === null) {
            Log.Error(
                `The widget type '${type}' is unknown, falling back to base widget class.`,
                null,
                __fileline
            );
        }

        switch (type) {
            case WidgetType.AD:
                return AdWidget;
            case WidgetType.ANNOUNCEMENT:
                return AnnouncementWidget;
            case WidgetType.BROADSIGN:
                return BroadsignWidget;
            case WidgetType.CONTENT:
                return ContentWidget;
            case WidgetType.CUSTOM_HTML:
                return CustomHtmlWidget;
            case WidgetType.GRAPHIC:
                return GraphicWidget;
            case WidgetType.HIVESTACK:
                return HivestackWidget;
            //Widget is abstract now and should not be instantiated
            // case WidgetType.General: return Widget;
            case WidgetType.IFRAME:
                return IframeWidget;
            case WidgetType.IFRAME_PREMIUM:
                return IframeWidget;
            case WidgetType.LABEL:
                return LabelWidget;
            case WidgetType.LIST:
                return ListWidget;
            case WidgetType.MAPS:
                return MapsWidget;
            case WidgetType.MEDALLION:
                return SocialMedallionWidget;
            case WidgetType.PLACE_EXCHANGE:
                return PlaceExchangeWidget;
            case WidgetType.POWERBI:
                return PowerBIWidget;
            case WidgetType.SCHEDULE:
                return ScheduleWidget;
            case WidgetType.SCORES:
                return ScoresWidget;
            case WidgetType.TICKER:
                return TickerWidget;
            case WidgetType.TIME_DATE:
                return TimeDateWidget;
            case WidgetType.VENGO:
                return VengoWidget;
            case WidgetType.VIDEO_STREAM:
                return VideoStreamWidget;
            case WidgetType.VISTAR:
                return VistarWidget;
            case WidgetType.WEATHER:
                return WeatherWidget;
            case WidgetType.WEATHER_RADAR:
                return WeatherRadarWidget;
            case WidgetType.COUNTER:
                return CounterWidget;
            case WidgetType.RADAR:
                return RadarWidget;
            case WidgetType.QUOTE:
                return QuoteWidget;

            default:
                throw new TypeError(`No Widget constructor for unknown Widget Type: ${type}`);
        }
    }
}
